interface IUser {
	readonly createdAt: Date;
	createdBy: null | string | User;
	readonly defaultAccount: null | string;
	readonly email: string;
	readonly grantType: string;
	readonly id: string;
	readonly isFederated: boolean;
	readonly name: null | string;
	readonly permissionCodes: string[];
	readonly status: string;
	readonly updatedAt: Date;
	updatedBy: null | string | User;
	readonly version: number;
}

export default class User implements IUser {
	public get createdAt(): Date {
		return this.#createdAt;
	}

	public get createdBy(): null | string | User {
		return this.#createdBy;
	}

	public set createdBy(value: null | string | User) {
		this.#createdBy = value;
	}

	public get defaultAccount(): null | string {
		return this.#defaultAccount;
	}

	public get email(): string {
		return this.#email;
	}

	public get grantType(): string {
		return this.#grantType;
	}

	public get id(): string {
		return this.#id;
	}

	public get isFederated(): boolean {
		return this.#isFederated;
	}

	public get name(): null | string {
		return this.#name;
	}

	public get permissionCodes(): string[] {
		return this.#permissionCodes;
	}

	public get status(): string {
		return this.#status;
	}

	public get updatedAt(): Date {
		return this.#updatedAt;
	}

	public get updatedBy(): null | string | User {
		return this.#updatedBy;
	}

	public set updatedBy(value: null | string | User) {
		this.#updatedBy = value;
	}

	public get version(): number {
		return this.#version;
	}

	#createdAt: Date;
	#createdBy: null | string | User;
	#defaultAccount: null | string;
	#email: string;
	#grantType: string;
	#id: string;
	#isFederated: boolean;
	#name: null | string;
	#permissionCodes: string[];
	#status: string;
	#updatedAt: Date;
	#updatedBy: null | string | User;
	#version: number;
	public constructor({ createdAt, createdBy, defaultAccount, email, grantType, id, isFederated, name, permissionCodes, status, updatedAt, updatedBy, version }: IUser) {
		this.#createdAt = createdAt;
		this.#createdBy = createdBy;
		this.#defaultAccount = defaultAccount;
		this.#email = email;
		this.#grantType = grantType;
		this.#id = id;
		this.#isFederated = isFederated;
		this.#name = name;
		this.#permissionCodes = permissionCodes;
		this.#status = status;
		this.#updatedAt = updatedAt;
		this.#updatedBy = updatedBy;
		this.#version = version;
	}
}
